import './App.css';
import './PageMarketingV2PresentVertical.css';

import { Button } from 'primereact/button';
import TotemStanding from './TotemStanding';

function PageMarketingV2PresentVertical({ creativeURL }) {
    return (
        <div align='center'>
            <div className='mk2-title'>
                Standing Vertical
            </div>
            <div className='mk2-present-vertical'>
                <div>
                    <div className='mk2-subtitle-small-right'>
                        Elegance meets innovation in our standing vertical TV, a modern masterpiece fusing cutting-edge technology with contemporary design.
                    </div>
                    <div className='mk2-subtitle-right'>
                        Starting from
                    </div>
                    <div className='mk2-title-right'>
                        9.9 EUR / month
                    </div>
                    <div>
                        <Button
                            label="View Offers"
                            severity="success"
                            outlined
                            size='small'
                        />
                    </div>
                </div>
                <div>
                    <TotemStanding
                        creativeURL={creativeURL}
                    />
                </div>
            </div>
        </div>
    )
}

export default PageMarketingV2PresentVertical;